import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { duplicateProjectAsync } from '../../actions';
import { addNewProject, findAndUpdateFolder } from '../../helpers';
import { VideoFolderActions } from '../../types';

const duplicateProjectReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(duplicateProjectAsync.request): {
      const params = action.payload;
      return {
        ...state,
        duplicateProject: {
          ...state.duplicateProject,
          params,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(duplicateProjectAsync.success): {
      const { folderId } = state.duplicateProject.params!;
      const duplicatedProject = action.payload;

      return {
        ...state,
        data: addNewProject(state.data!, duplicatedProject, folderId),
        folderTree: {
          ...state.folderTree,
          data: findAndUpdateFolder(
            state.folderTree.data!,
            folderId
          )(({ projectsCount = 0, ...other }) => ({
            ...other,
            projectsCount: projectsCount + 1
          }))
        },
        duplicateProject: {
          ...state.duplicateProject,
          data: duplicatedProject,
          isPending: false
        }
      };
    }

    case getType(duplicateProjectAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        duplicateProject: {
          ...state.duplicateProject,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default duplicateProjectReducer;
